/**
 * 使用菜勒公式计算出某一天是周几
 * year:年
 * month:月
 * day:日
 * c:世纪
 * y:年的后两位
 * w:星期（结果）
 */
export default function zellerWeek (year, month, day) {
  let m = month
  let d = day
  if (month <= 2) {
    year--
    m = month + 12
  }
  let c = parseInt(year / 100)
  let y = year - c * 100
  let w = y + parseInt(y / 4) + parseInt(c / 4) - 2 * c + parseInt(26 *(m + 1) / 10) + d - 1
  if (w < 0) {
    w += 7
  }
  w = parseInt(w % 7)
  return w
}